"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressIndicator = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_1 = require("react");
const Loader_1 = require("../Loader");
const AdaptableContext_1 = require("../../View/AdaptableContext");
const ProgressIndicator = () => {
    const { active, label } = (0, react_redux_1.useSelector)((state) => state.System.ProgressIndicator);
    const [visible, setVisible] = (0, react_1.useState)(false);
    const [progressIndicatorCoordinates, setProgressIndicatorCoordinates] = (0, react_1.useState)({
        top: 0,
        left: 0,
        height: 0,
        width: 0,
    });
    const adaptable = (0, AdaptableContext_1.useAdaptable)();
    const disableAdaptableGrid = (containerElement, disabled) => {
        const DISABLING_CSS_CLASS = 'ab-wait-for-progress-indicator';
        if (!containerElement) {
            return;
        }
        if (disabled) {
            containerElement.classList.add(DISABLING_CSS_CLASS);
        }
        else {
            containerElement.classList.remove(DISABLING_CSS_CLASS);
        }
    };
    const updateGridContainerCoordinates = (containerElement) => {
        if (!containerElement) {
            return;
        }
        const { top, left, height, width } = containerElement.getBoundingClientRect();
        setProgressIndicatorCoordinates({ top, left, height, width });
    };
    (0, react_1.useEffect)(() => {
        disableAdaptableGrid(adaptable.getAdaptableContainerElement(), active);
        disableAdaptableGrid(adaptable.getAgGridContainerElement(), active);
        updateGridContainerCoordinates(adaptable.getAdaptableContainerElement());
        // without rAF the progress indicator would be rendered instantly, without the 'transition-delay' defined via CSS
        requestAnimationFrame(() => {
            setVisible(active);
        });
    }, [active]);
    return (React.createElement(React.Fragment, null, active && (React.createElement("div", { className: `ab-progress-indicator-wrapper ${visible ? 'ab-progress-indicator-wrapper--visible' : ''}`, style: progressIndicatorCoordinates },
        React.createElement("div", { className: "ab-progress-indicator-body" },
            React.createElement(Loader_1.LoaderSpinner, null),
            React.createElement("span", { style: { marginLeft: 'var(--ab-space-2)' } }, label))))));
};
exports.ProgressIndicator = ProgressIndicator;
